export default __webpack_public_path__ + "static/media/secure.0b4a4d8d.png";